import React, { useState, useEffect } from "react";
import { Carousel, Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
const contentStyle = {
  margin: 0,
  height: "31rem",
  color: "#fff",
  lineHeight: "16rem",
  textAlign: "center",
  background: "#364d79",
};
const TemplatePreview = ({
  downloadPpt,
  download,
  previewModal,
  setPreviewModal,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);
  const [windowHeight, setWindowHeight] = useState(527);
  const ppt_template_data = useSelector(
    (state) => state?.PPT?.ppt_template_data
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setPreviewModal({
      preview: false,
      templateData: null,
    });
  };
  useEffect(() => {
    previewModal && setIsModalOpen(true);
  }, [previewModal]);

  const slideLeft = () => {
    setSlideIndex(slideIndex - 1);
  };
  const slideRight = () => {
    setSlideIndex(slideIndex + 1);
  };

  useEffect(() => {
    setWindowHeight(window?.innerHeight);
  }, [windowHeight]);
  return (
    <Modal
      style={{ top: windowHeight > 627 ? "" : 10 }}
      width={770}
      title={
        <div className="text_heading fontSize-16 font-weight500">
          Template Preview
        </div>
      }
      visible={download ? false : isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={
        <>
          <Button
            type="primary"
            onClick={() => handleCancel()}
            className="btn_Clear"
          >
            Back
          </Button>
          <Button
            type="primary"
            onClick={(e) => downloadPpt(e)}
            className="ant-btn-primary_blue"
            loading={download ? true : false}
          >
            {download ? "Generating PPT report..." : "Download PPT"}
          </Button>
        </>
      }
      className={`templatePreview ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
    >
      <div
        className={`position-absolute sliderLeft d-flex align-items-center ${
          slideIndex === 0 ? "disable" : ""
        }`}
        style={{ zIndex: "2" }}
      >
        <i
          className="fa slide-btn fa-angle-left cursor-pointer"
          onClick={() => slideLeft()}
        />
      </div>
      <div
        className={`position-absolute sliderRight d-flex align-items-center ${
          slideIndex === 3 ? "disable" : ""
        }`}
        style={{ zIndex: "2" }}
      >
        <i
          className="fa slide-btn fa-angle-right cursor-pointer"
          onClick={() => slideRight()}
        />
      </div>
      <div
        className="pptCarouselSlider position-relative"
        style={{ height: "37.2rem" }}
      >
        {previewModal?.templateData &&
          previewModal?.templateData?.template_images?.map((el, i) => {
            return (
              <div
                className={`pptSliderList ${
                  i === slideIndex ? "active" : ""
                } border-radius-4 bg__white box-shadow p-15 text-center`}
              >
                <div className="mb-15 pptSliderImages text-center">
                  <img
                    src={el}
                    style={{
                      maxHeight:
                        i === 0
                          ? "17.4rem"
                          : i === 1
                          ? "22rem"
                          : i === 2
                          ? "21rem"
                          : i === 3 && "17.4rem",
                    }}
                  />
                </div>
                <div className="font-weight500 text_regular">
                  {i === 0
                    ? "Dashboard Details Slide"
                    : i === 1
                    ? "Section Details Slide"
                    : i === 2
                    ? "Widget Slide"
                    : i === 3 && "Thank You Slide"}
                </div>
                <div className="line-height-normal text_regular">
                  {i === 0
                    ? "This is the first slide of ppt which contains report name, report description, brand names and duration."
                    : i === 1
                    ? "This is the section title and description slide. This slide will be followed by the widgets of a section."
                    : i === 2
                    ? "This slide contains one dashboard widget."
                    : i === 3 && "This will be the PPT's final slide."}
                </div>
              </div>
            );
          })}
      </div>
      <div className="w-100 d-flex align-items-center justify-content-center">
        {previewModal?.templateData?.template_images?.map((el, i) => {
          return (
            <div
              className="bg__gray border-radius-25 mr-1"
              style={{
                width: "1rem",
                height: "1rem",
                backgroundColor: i === slideIndex ? "#185edf" : "",
              }}
            />
          );
        })}
      </div>
    </Modal>
  );
};

export default TemplatePreview;
